import { InjectionToken } from "@angular/core";

export const I18N_APP_ID = new InjectionToken<string>('i18n.app.id');
export const MONITORING_AGENT = new InjectionToken<string>('monitoring.agent');
